import React from 'react';
import SvgIconDPC from "./dpc-svg-icon";

export default class DpcBackToTop extends React.Component {

    render(){
        return (
            <a href="#" aria-hidden="true" data-attribute="back-to-top" className="back-to-top" id="backToTop" title="Torna su">
                <SvgIconDPC name={'arrow-up'} color={'white'}/>
            </a>
        );
    }
}